<template>
  <div class="teacher-detail-wrapper" v-if="dataDone">
    <div class="teacher-center-container teahcer-header">
      <div class="teacher-avatar">
        <div class="avatar">
          <img v-if="teacherData.hd_img" :src="teacherData.hd_img">
        </div>
        <!-- <span class="teacher-level" :class="{'high-level': teacherData.level == 2}">
          <span v-if="teacherData.level == 1">优秀讲师</span>
          <span v-else-if="teacherData.level == 2">特级讲师</span>
          <span v-else-if="teacherData.level == 3">专业讲师</span>
          <span v-else-if="teacherData.level == 4">客座讲师</span>
        </span> -->
      </div>
      <div class="teacher-header-info">
        <div class="name">{{teacherData.name}}</div>
        <!-- <div class="service">{{teacherData.service.join('/')}}</div> -->
      </div>
    </div>
    <div class="audio-player-box" v-if="teacherData.audio">
      <audio-player :src="teacherData.audio"></audio-player>
    </div>
    <div class="teacher-main-wrapper">
      <div class="tab-wrapper" ref="courseTab">
        <div class="course-tab" :class="{'fixed': tabFixed}">
          <div class="tab-item" :class="{'active': activeTab == 'info'}" @click="tab('info')">基本信息</div>
          <div class="tab-item" :class="{'active': activeTab == 'course'}" @click="tab('course')">课程&文章</div>
          <div class="tab-item" :class="{'active': activeTab == 'comments'}" @click="tab('comments')">学生评价</div>
        </div>
      </div>
      <!-- 基本信息 -->
      <div class="teacher-base-info" ref="baseInfo">
        <div class="info-block">
          <div class="info-title">专业</div>
          <div class="info-content">
            <div class="major">{{teacherData.major.join('/')}}</div>
          </div>
        </div>
        <div class="info-block">
          <div class="info-title">熟悉的设计地域</div>
          <div class="info-content">
            <div class="major">{{teacherDetail.location.join('/')}}</div>
          </div>
        </div>
        <div class="info-block" v-if="teacherDetail.education && teacherDetail.education.length > 0">
          <div class="info-title">教育背景</div>
          <div class="info-content">
            <div class="exp-item" v-for="(item, index) in teacherDetail.education" :key="index">
              <div class="exp-title">{{item.university}}</div>
              <div class="exp-content">
                <span v-if="item.period || item.work">{{item.period ? item.period : item.work}}</span><span v-if="item.major">{{item.major}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="info-block" v-if="teacherDetail.career_list && teacherDetail.career_list.length > 0">
          <div class="info-title">工作经历</div>
          <div class="info-content">
            <div class="exp-item" v-for="(item, index) in teacherDetail.career_list" :key="index">
              <div class="exp-title">{{item.company}}</div>
              <div class="exp-content"><span>{{item.time}}</span><span v-if="item.city">{{item.city}}</span></div>
            </div>
          </div>
        </div>
        <div class="info-block" v-if="teacherDetail.award_list && teacherDetail.award_list.length > 0">
          <div class="info-title">已获荣誉</div>
          <div class="info-content">
            <div class="exp-item" v-for="(item, index) in teacherDetail.award_list" :key="index">
              <div class="exp-title">{{item.content}}</div>
              <div class="exp-content">{{item.time}}</div>
            </div>
          </div>
        </div>
        <div class="info-block" v-if="teacherDetail.desc_text">
          <div class="info-title">个人简介</div>
          <div class="info-content">
            <div class="personal-desc">{{teacherDetail.desc_text}}</div>
          </div>
        </div>
        <div class="info-block">
          <div class="info-title">当前城市</div>
          <div class="info-content">
            <div class="city">{{teacherDetail.city}}</div>
          </div>
        </div>
        <!-- 查看老师作品 -->
        <div class="portfolio" v-if="teacherDetail.portfolio" @click="checkPdf">查看老师作品</div>
      </div>
      <!-- 相关课程文章 -->
      <div class="teacher-courses" ref="courses" v-if="teacherCourses.studio.length > 0 || teacherCourses.article.length > 0">
        <div class="courses-title">Ta的课程</div>
        <div class="courses-list" :class="{'has-article': teacherCourses.article.length > 0}">
          <!-- 小组课 -->
          <!-- <router-link class="course-item" :to="{name: 'workshopDetail', params: {id: item.id}}" v-for="item in teacherCourses.workshop" :key="item.id" v-if="teacherCourses.workshop.length > 0">
            <div class="course-cover lazy-load"><img :src="item.thumb"></div>
            <div class="course-info">
              <div class="title">{{item.title}}</div>
              <div class="sub-info">
                小组课 |
                <span v-if="item.status == 2 && item.enrollEndSoon && !item.isStop">报名即将截止</span>
                <span v-if="item.status == 2 && !item.isStop">报名中</span>
                <span v-if="item.status == 2 && item.isStop">报名截止</span>
                <span v-if="item.status == 3">待发布</span>
              </div>
              <div class="course-score">
                <div class="score-box">
                  <icon icon-class="star" :class="{'bright': item.scoreStar >= 1}"></icon>
                  <icon icon-class="star" :class="{'bright': item.scoreStar >= 2}"></icon>
                  <icon icon-class="star" :class="{'bright': item.scoreStar >= 3}"></icon>
                  <icon icon-class="star" :class="{'bright': item.scoreStar >= 4}"></icon>
                  <icon icon-class="star" :class="{'bright': item.scoreStar >= 5}"></icon>
                </div>
                <span class="score">{{item.average_score}}</span>
              </div>
            </div>
          </router-link> -->
          <!-- 设计室 -->
          <router-link class="course-item" :to="{name: 'studioDetail', params: {id: item.id}}" v-for="item in teacherCourses.studio" :key="item.id" v-if="teacherCourses.studio.length > 0">
            <div class="course-cover lazy-load"><img :src="item.thumb"></div>
            <div class="course-info">
              <div class="title">{{item.title}}</div>
              <div class="sub-info">
                设计室 |
                <span v-if="item.status == 1">报名中</span>
                <span v-if="item.status == 2">进行中</span>
                <span v-if="item.status == 3">已结束</span>
              </div>
              <div class="course-score">
                <div class="score-box">
                  <icon icon-class="star" :class="{'bright': item.scoreStar >= 1}"></icon>
                  <icon icon-class="star" :class="{'bright': item.scoreStar >= 2}"></icon>
                  <icon icon-class="star" :class="{'bright': item.scoreStar >= 3}"></icon>
                  <icon icon-class="star" :class="{'bright': item.scoreStar >= 4}"></icon>
                  <icon icon-class="star" :class="{'bright': item.scoreStar >= 5}"></icon>
                </div>
                <span class="score">{{item.average_score}}</span>
              </div>
            </div>
          </router-link>
        </div>
        <div class="article-container" v-if="teacherCourses.article.length > 0">
          <div class="courses-title">Ta的文章</div>
          <div class="article-list">
            <router-link class="article-item" :to="{name: 'studioDetail', params: {id: item.id}}" v-for="item in teacherCourses.article" :key="item.id">
              <div class="article-cover lazy-load"><img :src="item.thumb" alt=""></div>
              <div class="article-title">{{item.title}}</div>
            </router-link>
          </div>
        </div>

      </div>
      <!-- 评价 -->
      <div class="teacher-comments" ref="comments" v-if="teacherCommentData.comments && teacherCommentData.comments.length > 0">
        <div class="comments-top">
          <div class="comments-header">
            <div class="total-score">{{teacherCommentData.score}}</div>
            <div class="score-text">
              <div class="text">老师评分 ({{teacherCommentData.count}}次)</div>
              <div class="star-box">
                <icon icon-class="star" :class="{'bright': teacherCommentData.scoreStar >= 1}"></icon>
                <icon icon-class="star" :class="{'bright': teacherCommentData.scoreStar >= 2}"></icon>
                <icon icon-class="star" :class="{'bright': teacherCommentData.scoreStar >= 3}"></icon>
                <icon icon-class="star" :class="{'bright': teacherCommentData.scoreStar >= 4}"></icon>
                <icon icon-class="star" :class="{'bright': teacherCommentData.scoreStar >= 5}"></icon>
              </div>
            </div>
          </div>
          <div class="tags-list" v-if="teacherCommentData.tags">
            <div class="tag-item" v-for="(item, index) in teacherCommentData.tags" :key="index">{{item.tag}}<span>({{item.count}})</span></div>
          </div>
        </div>
        <div class="comments-list">
          <div class="title">学生评价({{teacherCommentData.comments.length}})</div>
          <div class="comment-item" v-for="item in teacherCommentData.comments" :key="item.id">
            <div class="comment-avatar"><img :src="item.avatar"></div>
            <div class="comment-content">
              <div class="comment-name">
                <span v-if="item.anonymous == 0">{{item.username}}</span>
                <span v-if="item.anonymous == 1">匿名</span>
              </div>
              <!-- <div class="comment-course">
                <span v-if="item.type == 1">小组课 | {{item.course_title}}</span>
                <span v-if="item.type == 2">设计室 | {{item.course_title}}</span>
                <span v-if="item.type == 4 || item.type == 5">一对一</span>
              </div> -->
              <div class="comment-text">{{item.content}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部操作 -->
    <div class="workshop-control">
      <!-- 分享 -->
      <div class="control-item share" @click="share">
        <icon icon-class="new-share"></icon>
        <div class="control-text">分享</div>
      </div>
    </div>
    <share :src="locationHref" :title="teacherData.name" type="讲师" ref="shareComponent"></share>
  </div>
</template>

<style lang="less" scoped>
  .teacher-detail-wrapper{
    .teahcer-header{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-top: 16px;
      font-size: 14px;
      color: #333;
      padding: 0 16px;
      .teacher-avatar{
        position: relative;
        .avatar{
          width: 82px;
          height: 82px;
          border-radius: 50%;
          overflow: hidden;
          img{
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }
        .teacher-level{
          position: absolute;
          bottom: -7px;
          left: 50%;
          transform: translateX(-50%);
          width: 64px;
          height: 20px;
          line-height: 20px;
          text-align: center;
          color: #FFF;
          background: #55A4E1;
          border-radius: 20px;
          font-size: 12px;
          &.high-level{
            background: #F2BA49;
          }
        }
      }
      .teacher-header-info{
        margin-left: 20px;
        line-height: 20px;
        .name{
          font-size: 18px;
          line-height: 18px;
          // margin-bottom: 8px;
          font-weight: 600;
        }
        .service{
          font-size: 14px;
          line-height: 14px;
          color: #666;
        }
      }
    }
    .audio-player-box{
      margin-top: 20px;
      padding: 0 16px;
    }
    .teacher-main-wrapper{
      padding-top: 20px;
      .tab-wrapper{
        height: 34px;
        .course-tab{
          box-sizing: border-box;
          padding: 0 16px;
          background: #FFF;
          border-bottom: 1px solid #EEEEEE;
          height: 34px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          &.fixed{
            position: fixed;
            top: 87px;
            left: 0;
            width: 100%;
            z-index: 99;
          }
          .tab-item{
            position: relative;
            height: 34px;
            line-height: 34px;
            font-size: 14px;
            color: #999;
            margin-right: 16px;
            &.active{
              color: #333;
              font-weight: bold;
              &::after{
                content: '';
                position: absolute;
                left: 50%;
                bottom: 0;
                width: 24px;
                height: 3px;
                border-radius: 2px;
                background: @cano;
                transform: translateX(-50%);
              }
            }
          }
        }
      }
      .teacher-base-info{
        padding: 0 24px;
        .info-block{
          padding: 20px 0;
          border-bottom: 1px solid #F6F7F8;
          font-size: 14px;
          color: #333;
          .info-title{
            font-size: 16px;
            color: #333;
            line-height: 16px;
            margin-bottom: 14px;
            font-weight: bold;
          }
          .info-content{
            .major,
            .city{
              font-size: 16px;
              line-height: 20px;
              color: #333;
            }
            .exp-item{
              margin-bottom: 10px;
              &:last-child{
                margin-bottom: 0;
              }
              .exp-title{
                font-size: 16px;
                line-height: 20px;
                color: #333;
                /*font-weight: bold;*/
                margin-bottom: 5px;
              }
              .exp-content{
                font-size: 14px;
                color: #999;
                span + span::before{
                  content: ' | ';
                }
              }
            }
            .personal-desc{
              font-size: 14px;
              line-height: 20px;
              color: #333;
              word-break: break-all;
            }
          }

        }
        .portfolio{
          margin-top: 20px;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          height: 44px;
          border: 1px solid @cano;
          font-size: 16px;
          color: @cano;
          margin-bottom: 20px;
          border-radius: 44px;
        }
      }
      .teacher-courses{
        padding: 20px 24px 20px;
        border-top: 8px solid #F3F3F3;
        .courses-title{
          font-size: 16px;
          line-height: 16px;
          color: #333;
          font-weight: bold;
        }
        .courses-list{
          margin-top: 16px;
          &.has-article{
            padding-bottom: 20px;
            border-bottom: 1px solid #EEE;
          }
          .course-item{
            display: flex;
            justify-content: flex-start;
            height: 90px;
            box-shadow: 0 4px 10px 0 rgba(0,0,0,.06);
            border-radius: 6px;
            overflow: hidden;
            margin-bottom: 12px;
            overflow: hidden;
            &:last-child{
              margin-bottom: 0;
            }
            .course-cover{
              position: relative;
              width: 97px;
              height: 90px;
              overflow: hidden;
              img{
                position: absolute;
                height: 96px;
                width: 123px;
              }
            }
            .course-info{
              box-sizing: border-box;
              width: calc(100% - 97px);
              padding: 12px;
              .title{
                font-size: 16px;
                line-height: 16px;
                color: #333;
                font-weight: bold;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .sub-info{
                margin-top: 8px;
                font-size: 14px;
                line-height: 14px;
                color: #999;
              }
              .course-score{
                display: flex;
                justify-content: flex-start;
                align-items: center;
                margin-top: 12px;
                .score-box{
                  color: #EEE;
                  font-size: 14px;
                  .bright{
                    color: #4BA8C9;
                  }
                }
                .score{
                  font-size: 14px;
                  color: #999;
                  margin-left: 12px;
                }
              }
            }
          }
        }
        .article-container{
          margin-top: 20px;
          .article-list{
            margin-top: 11px;
            .article-item{
              display: flex;
              justify-content: flex-start;
              align-items: center;
              height: 90px;
              box-shadow: 0 4px 10px 0 rgba(0,0,0,.06);
              border-radius: 6px;
              overflow: hidden;
              margin-bottom: 12px;
              overflow: hidden;
              &:last-child{
                margin-bottom: 0;
              }
              .article-cover{
                flex-shrink: 0;
                position: relative;
                width: 97px;
                height: 90px;
                overflow: hidden;
                img{
                  position: absolute;
                  height: 96px;
                  width: 123px;
                }
              }
              .article-title{
                min-width: 0;
                padding: 0 20px 0 12px;
                font-size: 16px;
                line-height: 22px;
                color: #333;
                font-weight: 500;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
              }
            }
          }
        }
      }
      .teacher-comments{
        padding: 0 24px;
        border-top: 8px solid #F3F3F3;
        min-height: calc(100vh - 34px);
        .comments-top{
          border-bottom: 1px solid #F6F7F8;
          .comments-header{
            padding: 19px 0;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .total-score{
              font-size: 30px;
              line-height: 36px;
              color: #4BA8C9;
              font-weight: bold;
            }
            .score-text{
              padding-left: 16px;
              font-size: 16px;
              color: #333;
              .text{
                font-size: 16px;
                color: #333;
                line-height: 16px;
                margin-bottom: 5px;
              }
              .star-box{
                color: #EEE;
                font-size: 14px;
                .bright{
                  color: #4BA8C9;
                }
              }
            }
          }
          .tags-list{
            padding-bottom: 8px;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            flex-wrap: wrap;
            .tag-item{
              display: flex;
              justify-content: center;
              align-items: center;
              padding: 0 12px;
              height: 28px;
              background: #F3F3F3;
              margin: 0 12px 12px 0;
              font-size: 12px;
              color: #666;
              border-radius: 28px;
              span{
                color: #999;
              }
            }
          }
        }
        .comments-list{
          padding: 20px 0;
          .title{
            font-size: 16px;
            line-height: 16px;
            color: #333;
            font-weight: bold;
          }
          .comment-item{
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            margin-top: 16px;
            .comment-avatar{
              box-sizing: border-box;
              width: 44px;
              min-width: 44px;
              height: 44px;
              background: rgba(255,255,255,.18);
              padding: 3px;
              border-radius: 50%;
              overflow: hidden;
              img{
                width: 38px;
                height: 38px;
                border-radius: 50%;
                box-shadow: 0 2px 6px 0 rgba(0,0,0,.06);
              }
            }
            .comment-content{
              padding: 0 0 16px 12px;
              margin-top: 11px;
              border-bottom: 1px solid #F6F7F8;
              width: calc(100% - 38px);
              .comment-name{
                font-size: 14px;
                line-height: 14px;
                color: #333;
              }
              .comment-course{
                font-size: 12px;
                line-height: 12px;
                color: #999;
                margin-top: 6px;
              }
              .comment-text{
                font-size: 14px;
                line-height: 18px;
                color: #666;
                margin-top: 10px;
              }
            }
          }
        }
      }
    }
    /* 小组课底部操作 */
    .workshop-control{
      position: fixed;
      bottom: 0;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      width: 100%;
      height: 48px;
      border-top: 1px solid #BDBDBD;
      background-color: #fff;
      z-index: 990;
      &.iphonex{
        height: 67px;
      }
      .control-item{
        position: relative;
        box-sizing: border-box;
        // flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 48px;
        background-color: transparent;
        border: 0;
        color: #333;
        padding: 0 36px;
        .control-text{
          font-size: 12px;
          margin-left: 8px;
        }
      }
    }
  }
</style>

<script>
  import audioPlayer from '@/components/Common/audioPlayer'
  import share from '@/components/Common/share.vue'
  export default {
    data() {
      return {
        dataDone: false,
        teacherData: null,
        teacherDetail: null,
        teacherCourses: {
          workshop: [],
          studio: [],
          openlecture: [],
          article: [],
        },
        teacherCommentData: {
          tags: [],
          count: 0,
          score: 0,
          comments: [],
        },
        // 当前tab
        activeTab: 'info',
        // tab顶部偏移值
        tabOffset: 0,
        tabFixed: false,
        // 老师课程顶部偏移值
        coursesOffset: 0,
        // 老师评价顶部偏移值
        commentsOffset: 0,
        locationHref: '',
      }
    },
    created() {
      this.locationHref = window.location.href;
      this.$store.commit('setActiveMenu', 'lecturer')
      this.getBaseInfo();
    },
    beforeDestroy() {
      $(document).off('scroll', this.scrollHandler);
    },
    components: {
      audioPlayer,
      share
    },
    methods: {
      // 获取切换tab的顶部偏移值
      getTabOffset() {
        console.log(this.$refs.courseTab)
        this.tabOffset = this.$refs.courseTab.offsetTop;
      },
      // 获取&刷新每个内容区块的高度偏移值
      refreshOffset() {
        let haveCourses = this.teacherCourses.workshop.length > 0 || this.teacherCourses.studio.length > 0 || this.teacherCourses.article.length > 0;
        if(haveCourses) this.coursesOffset = this.$refs.courses.offsetTop - 48;
        if(this.teacherCommentData.comments.length > 0) this.commentsOffset = this.$refs.comments.offsetTop - 48;
        console.log(this.coursesOffset, this.commentsOffset)
      },
      scrollHandler() {
        let scrollTop = $(document).scrollTop();
        this.tabFixed = (scrollTop >= this.tabOffset - 48) ? true : false;
        if(scrollTop >= this.commentsOffset && this.commentsOffset != 0) {
          this.activeTab = 'comments';
        }else if(scrollTop >= this.coursesOffset && this.coursesOffset != 0) {
          this.activeTab = 'course';
        }else {
          this.activeTab = 'info';
        }
      },
      getBaseInfo() {
        this.$root.post('/Lecturer/get_lecturer_base', {
          tid: this.$route.params.id
        }).then(data => {
          this.teacherData = data.info;
          this.getLecturerDetail(() => {
            this.dataDone = true;
          })
          this.getTeacherCrouses();
          this.getComments();
        })
      },
      getLecturerDetail(cb) {
        this.$root.post('/Lecturer/get_lecturer_detail', {
          tid: this.$route.params.id,
          is_mobile: 1,
        }).then(data => {
          this.teacherDetail = data.info;
          cb && cb();
          this.$nextTick(() => {
            this.getTabOffset();
            this.refreshOffset();
            $(document).on('scroll', this.scrollHandler);
          })
        })
      },
      getTeacherCrouses() {
        this.$root.post('/Lecturer/get_lecturer_courses', {
          tid: this.$route.params.id,
        }).then(data => {
          // 处理小组课数据
          if(data.workshop && data.workshop.length > 0) {
            data.workshop.forEach(item => {
            // 报名截止前24小时，显示即将报名截止
            if ((item.starttime - 14400 - new Date().getTime() / 1000) <= (60 * 60 * 24)) {
              item.enrollEndSoon = true;
            }else {
              item.enrollEndSoon = false;
            }
            // 是否报名截止
            if ((item.starttime - 14400) <= (new Date().getTime() / 1000)) {
              item.isStop = true;
            }else {
              item.isStop = false;
            }
            // 评分
            if(parseInt(item.average_score) == 0) {
              item.average_score = '5.00';
            }
            item.scoreStar = Math.round(item.average_score);
          })
          }
          // 处理设计室数据
          data.studio.forEach(item => {
            if(parseInt(item.average_score) == 0) {
              item.average_score = '5.00';
            }
            item.scoreStar = Math.round(item.average_score);
          })
          this.teacherCourses = {
            workshop: data.workshop || [],
            studio: data.studio || [],
            openlecture: data.openlecture || [],
            article: data.article_list || [],
          }

          this.$nextTick(() => {
            this.refreshOffset();
          })
        })
      },
      getComments() {
        this.$root.post('/Lecturer/get_lecturer_comment_score', {
          tid: this.$route.params.id
        }).then(data => {
          this.teacherCommentData.tags = data.comment_tags;
          this.teacherCommentData.count = data.scount;
          this.teacherCommentData.score = data.score;
          this.$root.post('/Lecturer/get_lecturer_comment_list', {
            tid: this.$route.params.id
          }).then(data => {
            this.teacherCommentData.comments = data || [];
            setTimeout(() => {
              this.refreshOffset();
            }, 500);
          })
        })

      },
      share() {
        this.$refs.shareComponent.showMenu();
      },
      checkPdf() {
        window.open(this.teacherDetail.portfolio);
      },
    }
  }
</script>





// WEBPACK FOOTER //
// src/components/Lecturer/detail.vue